const styles = () => ({
  root: {
    margin: '0 0 50px',
    textAlign: 'center',
  },

  heading: {
    color: '#414953',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '1.71px',
    textTransform: 'uppercase',
  },
});

export default styles;
